export const formSettingsEn = {
  formSettings: {
    forms: {
      createNewForm: 'Create New Form',
      createModalTitle: 'What form type do you want to create?',
    },
    builder: {
      returnToForms: 'Return to all Forms',
      tabBuildForm: 'Build Form',
      tabEmailNotifications: 'Email Notification Settings',
      tabFormSettings: 'Form Settings',
      contentBlocksHeader: 'Content Blocks',
      searchContentBlocks: 'Search Content Blocks',
      searchContentBlocksPlaceholder: 'Search Content Blocks...',
      customizingBannerTitle: 'Customizing a Form',
      customizingBannerMessage: 'Drag a field from the left-hand side to add it to your form.',
      multiLangBannerMessage: 'When first setting up your translation forms, you can start with a copy of English fields. If there are existing fields, this will replace them with a copy of English fields.',
      copyFromEnglish: 'Copy from English',
      copied: 'Copied!',
      dragDropHint: 'Drag & drop blocks from left panel',
    },
    emailNotification: {
      submissionNotification: 'Submission Notification',
      autoResponseNotification: 'Auto-response Notification',
      scheduledFollowUp: 'Scheduled Follow up Notification (sent to the submitter)',
      submissionBannerMessage: 'When enabled, the following email will be sent to the specified contact below when the form is submitted.',
      subjectAndMessageSupport: 'Subject and message support',
      interpolationLink: 'interpolation.',
      autoResponseBannerMessage: 'When enabled, the following email will be sent to the person who submitted the form immediately on form submission.',
      followUpBannerMessage: 'When enabled, the following email will be sent to the person who submitted the form based on the specified time (via the "Delay" field). For waiting lists, the email will be sent when a unit becomes available.',
      contactEmail: 'Contact Email',
      maintenanceEmail: 'Maintenance Email',
      other: 'Other',
      enterOtherEmail: 'Enter other email...',
      invalidEmail: 'Invalid Email',
      overrideFromName: 'Override “From” Name',
      overrideFromEmail: 'Override “From” Email',
      chooseNameTooltipStandard: 'Choose which Name will be shown as the sender of the Standard Email',
      chooseEmailTooltipStandard: 'Choose which Email will be shown as the sender of the Standard Email',
      chooseNameTooltipDynamic: 'Choose which Name will be shown as the sender of the {sectionName}',
      chooseEmailTooltipDynamic: 'Choose which Email will be shown as the sender of the {sectionName}',
      defaultName: 'Default Name',
      customName: 'Custom Name',
      defaultEmail: 'Default email',
      customEmail: 'Custom email',
      customFromWarning: 'Please create a support ticket for managing custom \'From\' email settings.',
      emailSubject: 'Email Subject',
      emailMessage: 'Email Message',
      delay: 'Delay (# of hours)',
      expiry: 'Expiry (# of hours)',
      consentDisclaimer: 'Consent Disclaimer (Required)',
      includeRequestInAutoResponse: 'Include Request Details in Auto-Response',
      includeRequestInFollowUp: 'Include Request Details in Follow-Up',
      interpolationModalTitle: 'Interpolation',
      interpolationDescription1: 'This refers to adding dynamic data from your form into otherwise static text.',
      interpolationDescription2: 'All interpolation is done by adding a "key" in double square brackets within your text.',
      interpolationExample: 'Example: "Hi, [[full_name]]"',
      interpolationDescription3: 'The key can be the "Form Name" of any field in your form (located under "Show Advanced"). If your Form Name says "[auto]", you can add one yourself or save the form to generate one first.',
      interpolationDescription4: 'Interpolation keys can also be one of the following predefined keys, which refer to the details of a property or city if one is selected in some way.',
      interpolationProspect: 'Prospect:',
      interpolationProperty: 'Property:',
      interpolationCity: 'City:',
    },
    formSettingsTab: {
      captchaType: 'CAPTCHA Type',
      applyValidationRules: 'Apply Validation Rules to this form',
      noUrls: 'Does not have URLs',
      noHtml: 'Does not have HTML',
      noCyrillic: 'Does not have cyrillic characters',
      noCjk: 'Does not have CJK characters',
      trackingCodeSetup: 'Tracking Code - Setup',
      trackingCodeApply: 'Tracking Code - Apply',
      submitButtonText: 'Submit Button Text',
      successUrl: 'Success URL',
      successUrlTooltip: 'Please reach out to support to implement Success URL.',
      successMessage: 'Success Message',
      errorMessage: 'Error Message',
      uniqueFormKey: 'Unique Form Key',
      formKeyExists: 'This Form Key already exists!',
      formName: 'Form Name',
      formTitle: 'Form Title',
      formType: 'Form Type',
      formStatus: 'Form Status',
      formSettingsTranslations: 'Form Settings Translations',
      formFieldsTranslations: 'Form Fields Translations',
    },
    fieldConfig: {
      title: 'Title',
      saveType: 'Save Type',
      options: 'Options',
      fieldType: 'Field Type',
      validator: 'Validator',
      defaultValue: 'Default Value',
      min: 'Min',
      max: 'Max',
      allowedFiles: 'Allowed Files',
      placeholder: 'Placeholder',
      showAdvancedSettings: 'Show Advanced Settings',
      shortLabel: 'Short Label',
      autoComplete: 'Auto-Complete',
      valueWhenEmpty: 'Value When Empty',
      formName: 'Form Name',
      cssClass: 'CSS Class',
      behaviour: 'Behaviour',
      excludeField: 'Exclude Field',
      earliestMoveInDate: 'Earliest Move-In Date',
      dataSource: 'Data Source',
      dataRestriction: 'Data Restriction',
      dataLabel: 'Data Label',
      dataValue: 'Data Value',
      showConditional: 'Show Conditional',
      existenceBasedOnField: 'Existence Based on Field',
      whenSpecifiedField: 'When Specified Field',
      value: 'Value',
      showIntegrationSettings: 'Show Integration Settings',
      integrationName: 'Integration Name',
      required: 'Required',
      selectField: 'Select field...',
      addOption: 'ADD OPTION',
      optionLabelPlaceholder: 'Label',
      optionValuePlaceholder: 'Value',
      toggleDefaultOption: 'Toggle default selected option',
      duplicateFieldTitle: 'Duplicate this field?',
      removeBlockTitle: 'Remove Content Block',
      removeBlockText: 'Are you sure you want to remove this content block "{name}"? This action cannot be undone.',
      removeBlockConfirm: 'Remove',
    },
    contentBlocks: {
      name: { title: 'Name', subtitle: 'Single line for full name', label: 'Full Name' },
      email: { title: 'Email', subtitle: 'Single line for email', label: 'Email' },
      phone: { title: 'Phone', subtitle: 'Single line for phone', label: 'Phone' },
      inquiringProperty: {
        title: 'Inquiring about a property?',
        subtitle: 'Property Inquiry',
        label: 'Inquiring about a property?',
        yes: 'Yes',
        no: 'No',
      },
      selectCity: {
        title: 'Select a City',
        subtitle: 'Multi-option for city',
        label: 'Select a City',
        pleaseSelect: 'Please select...',
      },
      selectProperty: {
        title: 'Select a Property',
        subtitle: 'Multi-option for properties',
        label: 'Select a Property',
        pleaseSelect: 'Please select...',
      },
      selectUnitType: {
        title: 'Select a Unit Type',
        subtitle: 'Multi-option for unit types',
        label: 'Select a Unit Type',
        pleaseSelect: 'Please select...',
      },
      unitNumber: { title: 'Unit Number', subtitle: 'Single line for unit number', label: 'Unit Number' },
      numberOfBedrooms: { title: 'Number of Bedrooms', subtitle: 'Single line for bedrooms', label: 'Number of Bedrooms' },
      moveInDate: { title: 'Move-in Date', subtitle: 'Single line for date', label: 'Move-in Date' },
      comments: { title: 'Comments', subtitle: 'Input for comments', label: 'Comments' },
      textField: { title: 'Text Field', subtitle: 'Input for text field', label: 'Text Field' },
      selectBox: { title: 'Select Box', subtitle: 'Input for select box', label: 'Select Box' },
      checkbox: { title: 'Checkbox', subtitle: 'Input for checkbox', label: 'Checkbox' },
      groupedCheckboxes: {
        title: 'Grouped Checkboxes',
        subtitle: 'Input for checkboxes',
        label: 'Grouped Checkboxes',
        option1: 'Option 1',
      },
      radioButtons: {
        title: 'Radio Buttons',
        subtitle: 'Input for radio buttons',
        label: 'Radio Buttons',
        option1: 'Option 1',
        option2: 'Option 2',
        option3: 'Option 3',
      },
      textArea: { title: 'Text Area', subtitle: 'Input for text area', label: 'Text Area' },
      fileUpload: { title: 'File Upload', subtitle: 'Input for file upload', label: 'File Upload' },
      displayText: { title: 'Display Text', subtitle: 'Single line for display text', label: 'Display Text' },
      number: { title: 'Number', subtitle: 'Single line for number entry', label: 'Number' },
    },
    fieldTypes: {
      career: 'Career',
      contact: 'Contact',
      generic: 'Generic',
      inquiry: 'Inquiry',
      maintenanceRequest: 'Maintenance Request',
      waitingList: 'Waiting List',
      plainText: 'Plain Text',
      number: 'Number',
      date: 'Date',
      phoneNumber: 'Phone Number',
      email: 'Email',
      password: 'Password',
      hidden: 'Hidden',
      na: 'N/A',
      name: 'Name',
      firstName: 'First Name',
      lastName: 'Last Name',
      phone: 'Phone',
      propertyToggle: 'Inquiring about an apartment?',
      city: 'City',
      property: 'Property',
      unit: 'Unit',
      unitName: 'Unit Name',
      unitNumber: 'Unit Number',
      numberOfBedrooms: 'Number of Bedrooms',
      moveInDate: 'Move-in Date',
      maintenanceCategory: 'Maintenance Category',
      authorizationDisclaimer: 'Authorization / Disclaimer',
      comments: 'Comments / Description',
      inquiryType: 'Inquiry Type ("inquiry" or "viewing")',
      togglesInquiring: 'Toggles inquiring about a property',
      selectsProperty: 'Selects or narrows down a property to inquire about',
      onlyShownIfInquiring: 'Only shown if inquiring about a property',
      selectsCareer: 'Selects a career to inquire about',
      on: 'On',
      off: 'Off',
      excludeFromEmail: 'Exclude From Email',
      excludeFromInquiry: 'Exclude From Inquiry',
      both: 'Both',
      citiesOffered: 'Cities Offered',
      properties: 'Properties',
      units: 'Units',
      careers: 'Careers',
      residential: 'Residential',
      commercial: 'Commercial',
      anyStandardFiles: 'Any Standard Files',
      imageFiles: 'Image Files',
      documents: 'Documents',
      pdfOnly: 'PDF Only',
      exists: 'Exists',
      hasAValue: 'has a value',
      doesNotHaveAValue: 'does not have a value',
      hasTheFollowingValue: 'has the following value:',
      doesNotHaveTheFollowingValue: 'does not have the following value:',
      none: 'None',
      basic: 'Basic',
      recaptcha: 'reCAPTCHA',
    },
    toasts: {
      unsavedChanges: 'You have unsaved changes!',
      fieldConfigErrors: 'Your form fields have some configuration errors in either Advanced or Conditional Settings! Please fix before saving.',
      formErrors: 'You have some errors! Please fix before saving.',
      saving: 'Saving form',
      savedTitle: 'Changes Saved!',
      savedMessage: 'Your changes to the custom form have been successfully saved.',
      deleteFormTitle: 'Delete Custom Form',
      deleteFormText: 'Are you sure you want to remove this custom form? This action cannot be undone.',
      deleteFormConfirm: 'Delete',
      deletedTitle: 'Custom Form Deleted!',
      deletedMessage: 'Your custom form has been successfully deleted.',
    },
  },
} as const;

export const formSettingsFr = {
  formSettings: {
    forms: {
      createNewForm: 'Créer un nouveau formulaire',
      createModalTitle: 'Quel type de formulaire voulez-vous créer?',
    },
    builder: {
      returnToForms: 'Retour à tous les formulaires',
      tabBuildForm: 'Créer le formulaire',
      tabEmailNotifications: 'Paramètres de notification par courriel',
      tabFormSettings: 'Paramètres du formulaire',
      contentBlocksHeader: 'Blocs de contenu',
      searchContentBlocks: 'Rechercher des blocs de contenu',
      searchContentBlocksPlaceholder: 'Rechercher des blocs de contenu...',
      customizingBannerTitle: 'Personnaliser un formulaire',
      customizingBannerMessage: 'Faites glisser un champ depuis le panneau gauche pour l\'ajouter à votre formulaire.',
      multiLangBannerMessage: 'Lors de la première configuration de vos formulaires de traduction, vous pouvez commencer avec une copie des champs anglais. Si des champs existent déjà, ils seront remplacés par une copie des champs anglais.',
      copyFromEnglish: 'Copier depuis l\'anglais',
      copied: 'Copié!',
      dragDropHint: 'Glisser-déposer des blocs depuis le panneau gauche',
    },
    emailNotification: {
      submissionNotification: 'Notification de soumission',
      autoResponseNotification: 'Notification de réponse automatique',
      scheduledFollowUp: 'Notification de suivi planifié (envoyée au soumetteur)',
      submissionBannerMessage: 'Lorsqu\'activé, le courriel suivant sera envoyé au contact spécifié ci-dessous lors de la soumission du formulaire.',
      subjectAndMessageSupport: 'L\'objet et le message prennent en charge',
      interpolationLink: 'l\'interpolation.',
      autoResponseBannerMessage: 'Lorsqu\'activé, le courriel suivant sera envoyé à la personne ayant soumis le formulaire immédiatement après la soumission.',
      followUpBannerMessage: 'Lorsqu\'activé, le courriel suivant sera envoyé à la personne ayant soumis le formulaire selon le délai spécifié (via le champ « Délai »). Pour les listes d\'attente, le courriel sera envoyé lorsqu\'une unité devient disponible.',
      contactEmail: 'Courriel du contact',
      maintenanceEmail: 'Courriel de maintenance',
      other: 'Autre',
      enterOtherEmail: 'Entrer un autre courriel...',
      invalidEmail: 'Courriel invalide',
      overrideFromName: 'Remplacer le nom « De »',
      overrideFromEmail: 'Remplacer le courriel « De »',
      chooseNameTooltipStandard: 'Choisir le nom qui sera affiché comme expéditeur du courriel standard',
      chooseEmailTooltipStandard: 'Choisir le courriel qui sera affiché comme expéditeur du courriel standard',
      chooseNameTooltipDynamic: 'Choisir le nom qui sera affiché comme expéditeur de {sectionName}',
      chooseEmailTooltipDynamic: 'Choisir le courriel qui sera affiché comme expéditeur de {sectionName}',
      defaultName: 'Nom par défaut',
      customName: 'Nom personnalisé',
      defaultEmail: 'Courriel par défaut',
      customEmail: 'Courriel personnalisé',
      customFromWarning: 'Veuillez créer un billet de soutien pour gérer les paramètres de courriel d\'expéditeur personnalisés.',
      emailSubject: 'Objet du courriel',
      emailMessage: 'Message du courriel',
      delay: 'Délai (# d\'heures)',
      expiry: 'Expiration (# d\'heures)',
      consentDisclaimer: 'Avis de consentement (obligatoire)',
      includeRequestInAutoResponse: 'Inclure les détails de la demande dans la réponse automatique',
      includeRequestInFollowUp: 'Inclure les détails de la demande dans le suivi',
      interpolationModalTitle: 'Interpolation',
      interpolationDescription1: 'Ceci fait référence à l\'ajout de données dynamiques de votre formulaire dans un texte autrement statique.',
      interpolationDescription2: 'Toute interpolation se fait en ajoutant une « clé » entre doubles crochets dans votre texte.',
      interpolationExample: 'Exemple: "Bonjour, [[full_name]]"',
      interpolationDescription3: 'La clé peut être le « Nom du formulaire » de n\'importe quel champ de votre formulaire (situé sous « Afficher les paramètres avancés »). Si le nom de votre formulaire indique « [auto] », vous pouvez en ajouter un vous-même ou enregistrer le formulaire pour en générer un d\'abord.',
      interpolationDescription4: 'Les clés d\'interpolation peuvent également être l\'une des clés prédéfinies suivantes, qui font référence aux détails d\'une propriété ou d\'une ville si l\'une d\'elles est sélectionnée.',
      interpolationProspect: 'Prospect:',
      interpolationProperty: 'Propriété:',
      interpolationCity: 'Ville:',
    },
    formSettingsTab: {
      captchaType: 'Type de CAPTCHA',
      applyValidationRules: 'Appliquer des règles de validation à ce formulaire',
      noUrls: 'Ne contient pas d\'URLs',
      noHtml: 'Ne contient pas de HTML',
      noCyrillic: 'Ne contient pas de caractères cyrilliques',
      noCjk: 'Ne contient pas de caractères CJC',
      trackingCodeSetup: 'Code de suivi - Configuration',
      trackingCodeApply: 'Code de suivi - Appliquer',
      submitButtonText: 'Texte du bouton de soumission',
      successUrl: 'URL de succès',
      successUrlTooltip: 'Veuillez contacter le support pour implémenter l\'URL de succès.',
      successMessage: 'Message de succès',
      errorMessage: 'Message d\'erreur',
      uniqueFormKey: 'Clé de formulaire unique',
      formKeyExists: 'Cette clé de formulaire existe déjà!',
      formName: 'Nom du formulaire',
      formTitle: 'Titre du formulaire',
      formType: 'Type de formulaire',
      formStatus: 'Statut du formulaire',
      formSettingsTranslations: 'Traductions des paramètres du formulaire',
      formFieldsTranslations: 'Traductions des champs du formulaire',
    },
    fieldConfig: {
      title: 'Titre',
      saveType: 'Type d\'enregistrement',
      options: 'Options',
      fieldType: 'Type de champ',
      validator: 'Validateur',
      defaultValue: 'Valeur par défaut',
      min: 'Min',
      max: 'Max',
      allowedFiles: 'Fichiers autorisés',
      placeholder: 'Espace réservé',
      showAdvancedSettings: 'Afficher les paramètres avancés',
      shortLabel: 'Étiquette courte',
      autoComplete: 'Remplissage automatique',
      valueWhenEmpty: 'Valeur lorsque vide',
      formName: 'Nom du formulaire',
      cssClass: 'Classe CSS',
      behaviour: 'Comportement',
      excludeField: 'Exclure le champ',
      earliestMoveInDate: 'Date d\'emménagement la plus tôt',
      dataSource: 'Source de données',
      dataRestriction: 'Restriction des données',
      dataLabel: 'Étiquette des données',
      dataValue: 'Valeur des données',
      showConditional: 'Afficher la condition',
      existenceBasedOnField: 'Existence basée sur le champ',
      whenSpecifiedField: 'Lorsque le champ spécifié',
      value: 'Valeur',
      showIntegrationSettings: 'Afficher les paramètres d\'intégration',
      integrationName: 'Nom de l\'intégration',
      required: 'Obligatoire',
      selectField: 'Sélectionner un champ...',
      addOption: 'AJOUTER UNE OPTION',
      optionLabelPlaceholder: 'Étiquette',
      optionValuePlaceholder: 'Valeur',
      toggleDefaultOption: 'Basculer l\'option sélectionnée par défaut',
      duplicateFieldTitle: 'Dupliquer ce champ?',
      removeBlockTitle: 'Supprimer le bloc de contenu',
      removeBlockText: 'Êtes-vous sûr de vouloir supprimer ce bloc de contenu « {name} »? Cette action ne peut pas être annulée.',
      removeBlockConfirm: 'Supprimer',
    },
    contentBlocks: {
      name: { title: 'Nom', subtitle: 'Ligne unique pour le nom complet', label: 'Nom complet' },
      email: { title: 'Courriel', subtitle: 'Ligne unique pour le courriel', label: 'Courriel' },
      phone: { title: 'Téléphone', subtitle: 'Ligne unique pour le téléphone', label: 'Téléphone' },
      inquiringProperty: {
        title: 'Intéressé par une propriété?',
        subtitle: 'Demande de propriété',
        label: 'Intéressé par une propriété?',
        yes: 'Oui',
        no: 'Non',
      },
      selectCity: {
        title: 'Sélectionner une ville',
        subtitle: 'Option multiple pour la ville',
        label: 'Sélectionner une ville',
        pleaseSelect: 'Veuillez sélectionner...',
      },
      selectProperty: {
        title: 'Sélectionner une propriété',
        subtitle: 'Option multiple pour les propriétés',
        label: 'Sélectionner une propriété',
        pleaseSelect: 'Veuillez sélectionner...',
      },
      selectUnitType: {
        title: 'Sélectionner un type d\'unité',
        subtitle: 'Option multiple pour les types d\'unités',
        label: 'Sélectionner un type d\'unité',
        pleaseSelect: 'Veuillez sélectionner...',
      },
      unitNumber: { title: 'Numéro d\'unité', subtitle: 'Ligne unique pour le numéro d\'unité', label: 'Numéro d\'unité' },
      numberOfBedrooms: { title: 'Nombre de chambres', subtitle: 'Ligne unique pour les chambres', label: 'Nombre de chambres' },
      moveInDate: { title: 'Date d\'emménagement', subtitle: 'Ligne unique pour la date', label: 'Date d\'emménagement' },
      comments: { title: 'Commentaires', subtitle: 'Champ pour les commentaires', label: 'Commentaires' },
      textField: { title: 'Champ texte', subtitle: 'Champ pour la saisie de texte', label: 'Champ texte' },
      selectBox: { title: 'Liste déroulante', subtitle: 'Champ pour une liste déroulante', label: 'Liste déroulante' },
      checkbox: { title: 'Case à cocher', subtitle: 'Champ pour une case à cocher', label: 'Case à cocher' },
      groupedCheckboxes: {
        title: 'Cases à cocher groupées',
        subtitle: 'Champ pour des cases à cocher',
        label: 'Cases à cocher groupées',
        option1: 'Option 1',
      },
      radioButtons: {
        title: 'Boutons radio',
        subtitle: 'Champ pour des boutons radio',
        label: 'Boutons radio',
        option1: 'Option 1',
        option2: 'Option 2',
        option3: 'Option 3',
      },
      textArea: { title: 'Zone de texte', subtitle: 'Champ pour une zone de texte', label: 'Zone de texte' },
      fileUpload: { title: 'Téléversement de fichier', subtitle: 'Champ pour le téléversement de fichier', label: 'Téléversement de fichier' },
      displayText: { title: 'Texte affiché', subtitle: 'Ligne unique pour le texte affiché', label: 'Texte affiché' },
      number: { title: 'Nombre', subtitle: 'Ligne unique pour la saisie de nombre', label: 'Nombre' },
    },
    fieldTypes: {
      career: 'Carrière',
      contact: 'Contact',
      generic: 'Générique',
      inquiry: 'Demande',
      maintenanceRequest: 'Demande de maintenance',
      waitingList: 'Liste d\'attente',
      plainText: 'Texte simple',
      number: 'Nombre',
      date: 'Date',
      phoneNumber: 'Numéro de téléphone',
      email: 'Courriel',
      password: 'Mot de passe',
      hidden: 'Masqué',
      na: 'S.O.',
      name: 'Nom',
      firstName: 'Prénom',
      lastName: 'Nom de famille',
      phone: 'Téléphone',
      propertyToggle: 'Intéressé par un appartement?',
      city: 'Ville',
      property: 'Propriété',
      unit: 'Unité',
      unitName: 'Nom de l\'unité',
      unitNumber: 'Numéro d\'unité',
      numberOfBedrooms: 'Nombre de chambres',
      moveInDate: 'Date d\'emménagement',
      maintenanceCategory: 'Catégorie de maintenance',
      authorizationDisclaimer: 'Autorisation / Avis',
      comments: 'Commentaires / Description',
      inquiryType: 'Type de demande ("inquiry" ou "viewing")',
      togglesInquiring: 'Bascule pour s\'enquérir d\'une propriété',
      selectsProperty: 'Sélectionne ou affine la propriété à s\'enquérir',
      onlyShownIfInquiring: 'Affiché uniquement si s\'enquérant d\'une propriété',
      selectsCareer: 'Sélectionne une carrière à s\'enquérir',
      on: 'Activé',
      off: 'Désactivé',
      excludeFromEmail: 'Exclure du courriel',
      excludeFromInquiry: 'Exclure de la demande',
      both: 'Les deux',
      citiesOffered: 'Villes offertes',
      properties: 'Propriétés',
      units: 'Unités',
      careers: 'Carrières',
      residential: 'Résidentiel',
      commercial: 'Commercial',
      anyStandardFiles: 'Tous les fichiers standards',
      imageFiles: 'Fichiers image',
      documents: 'Documents',
      pdfOnly: 'PDF seulement',
      exists: 'Existe',
      hasAValue: 'a une valeur',
      doesNotHaveAValue: 'n\'a pas de valeur',
      hasTheFollowingValue: 'a la valeur suivante:',
      doesNotHaveTheFollowingValue: 'n\'a pas la valeur suivante:',
      none: 'Aucun',
      basic: 'Basique',
      recaptcha: 'reCAPTCHA',
    },
    toasts: {
      unsavedChanges: 'Vous avez des modifications non enregistrées!',
      fieldConfigErrors: 'Vos champs de formulaire contiennent des erreurs de configuration dans les paramètres avancés ou conditionnels! Veuillez corriger avant d\'enregistrer.',
      formErrors: 'Vous avez des erreurs! Veuillez les corriger avant d\'enregistrer.',
      saving: 'Enregistrement du formulaire',
      savedTitle: 'Modifications enregistrées!',
      savedMessage: 'Vos modifications au formulaire personnalisé ont été enregistrées avec succès.',
      deleteFormTitle: 'Supprimer le formulaire personnalisé',
      deleteFormText: 'Êtes-vous sûr de vouloir supprimer ce formulaire personnalisé? Cette action ne peut pas être annulée.',
      deleteFormConfirm: 'Supprimer',
      deletedTitle: 'Formulaire personnalisé supprimé!',
      deletedMessage: 'Votre formulaire personnalisé a été supprimé avec succès.',
    },
  },
} as const;
